const DeviceOrientation = {
  invoke: {
    getDeviceOrientation: () => {
      return window.matchMedia('(orientation: landscape)').matches
        ? 'landscape'
        : 'portrait';
    },

    getDeviceOrientationDependingOnScreenRatio: () => {
      return window.matchMedia('(min-aspect-ratio: 13/9)').matches
        ? 'landscape'
        : 'portrait';
    },
    getScreenSize: () => {
      return window.matchMedia('(min-width: 768px) and (max-width: 1024px)')
        .matches
        ? 'medium'
        : window.innerWidth < 768
        ? 'small'
        : 'wide';
    },
  },
  on: {
    onScreenSizeChange(callback: Function) {
      const mqlSmallMax = window.matchMedia('(max-width: 768px)');
      const mqlLarge = window.matchMedia('(min-width: 1025px)');
      let size: string;
      const listener = () => {
        if (window.innerWidth < 768) {
          size = 'small';
        } else {
          size = window.innerWidth > 1024 ? 'wide' : 'medium';
        }

        callback(size);
      };

      try {
        // Chrome & Firefox
        mqlSmallMax.addEventListener('change', listener);
        mqlLarge.addEventListener('change', listener);
      } catch (e1) {
        // Safari
        mqlSmallMax.addListener(listener);
        mqlLarge.addListener(listener);
      }

      return () => {
        try {
          // Chrome & Firefox
          mqlSmallMax.removeEventListener('change', listener);
          mqlLarge.removeEventListener('change', listener);
        } catch (e1) {
          //Safari
          mqlSmallMax.removeListener(listener);
          mqlLarge.removeListener(listener);
        }
      };
    },
  },
};

export default DeviceOrientation;
